export const HOME = {
  emergentLink: "home-emergent-link",
  brand: "home-brand",
  startReading: "home-start-reading",
  historyLink: "nav-history-link",
  langToggle: "lang-toggle-button",
  disclaimerCheckbox: "home-disclaimer-checkbox",
  priceSingle: "home-price-single",
  pricePack3: "home-price-pack3",
  buySingle: "home-buy-single",
  buyPack3: "home-buy-pack3",
  inlineForm: "home-inline-auth-form",
  inlineRegisterBtn: "home-inline-register-btn",
  inlineLoginBtn: "home-inline-login-btn",
  inlineToggleMode: "home-inline-toggle-mode",
  continueBtn: "home-continue-btn",
  dailyBtn: "home-daily-btn",
  readingBtn: "home-reading-btn",
};

export const WELCOME = {
  page: "welcome-page",
  greeting: "welcome-greeting",
  startBtn: "welcome-start-btn",
};

export const AUTH = {
  registerPage: "auth-register-page",
  loginPage: "auth-login-page",
  registerEmail: "auth-register-email",
  registerPassword: "auth-register-password",
  registerFirstName: "auth-register-first-name",
  registerSubmit: "auth-register-submit",
  loginEmail: "auth-login-email",
  loginPassword: "auth-login-password",
  loginSubmit: "auth-login-submit",
  toLogin: "auth-to-login",
  toRegister: "auth-to-register",
  logoutBtn: "auth-logout-btn",
  navLogin: "auth-nav-login",
  navRegister: "auth-nav-register",
  creditBadge: "auth-credit-badge",
  errorMsg: "auth-error-msg",
};

export const PAY = {
  buySingle: "pay-buy-single",
  buyPack3: "pay-buy-pack3",
  successPage: "pay-success-page",
  cancelPage: "pay-cancel-page",
  pricingSection: "pay-pricing-section",
};

export const READING = {
  root: "reading-page",
  shuffleBtn: "reading-shuffle-btn",
  drawConsultantBtn: "reading-draw-consultant-btn",
  consultantCard: "reading-consultant-card",
  consultantInterp: "reading-consultant-interpretation",
  continueToQuestion: "reading-continue-to-question",
  questionCustomBtn: "reading-question-custom-btn",
  questionWisdomBtn: "reading-question-wisdom-btn",
  questionInput: "reading-question-input",
  continueToCross: "reading-continue-to-cross",
  slot: (pos) => `reading-slot-${pos}`,
  deckCard: (i) => `deck-card-${i}`,
  revealBtn: "reading-reveal-btn",
  crossInterp: "reading-cross-interpretation",
  restartBtn: "reading-restart-btn",
  newQuestionBtn: "reading-new-question-btn",
  endBtn: "reading-end-session-btn",
  copyBtn: "reading-copy-btn",
  printBtn: "reading-print-btn",
  downloadPngBtn: "reading-download-png-btn",
  shareImageBtn: "reading-share-image-btn",
  emailMemoBtn: "reading-email-memo-btn",
  dailyCardBtn: "reading-daily-card-btn",
  emailMemoInput: "reading-email-memo-input",
  emailMemoSend: "reading-email-memo-send",
  emailMemoForm: "reading-email-memo-form",
  downloadStoryBtn: "reading-download-story-btn",
  shareCard: "reading-share-card",
  shareCardStory: "reading-share-card-story",
  backHome: "reading-back-home",
  focusToggleBtn: "reading-focus-toggle-btn",
  focusExitBtn: "reading-focus-exit-btn",
  backToTopBtn: "reading-back-to-top-btn",
  firstNameInput: "reading-first-name-input",
  firstNameContinue: "reading-first-name-continue",
  buyMoreBtn: "reading-buy-more-btn",
  outOfCreditsBanner: "reading-out-of-credits",
};

export const HISTORY = {
  root: "history-page",
  entry: (id) => `history-entry-${id}`,
  deleteBtn: (id) => `history-delete-${id}`,
  pinBtn: (id) => `history-pin-${id}`,
  openBtn: (id) => `history-open-${id}`,
  clearAllBtn: "history-clear-all-btn",
  emptyMsg: "history-empty-msg",
  backHome: "history-back-home",
  statsToggle: "history-stats-toggle",
  statsPanel: "history-stats-panel",
  streakBadge: "history-streak-badge",
};

export const ADMIN = {
  page: "admin-page",
  claimLink: "admin-claim-link",
  copyEnvBtn: "admin-copy-env-btn",
  navLink: "admin-nav-link",
};
